/* Valuation forms with photo upload (sections/tc-valuation-form.liquid).
   Loaded only when Theme settings → "Valuation photos endpoint" (a Make webhook URL) is set.
   1. Resize the chosen photos in the browser (max 1400px JPEG, ~150–250 KB each).
   2. Send the enquiry fields + photos to Make as one form field "payload" (JSON). This is a
      "simple" request, so the browser needs no CORS preflight; Make parses the JSON, emails the
      photos to Nick and creates/updates the Shopify customer with consent.
   3. Then submit the normal Shopify contact form as usual, so the enquiry always reaches the inbox
      even if Make is down (only the photos would be missing). */
(() => {
  const MAX_SIDE = 1400;
  const QUALITY = 0.78;
  const MAX_TOTAL = 4.2 * 1024 * 1024; // stay under Make's 5 MB webhook limit (base64 adds ~33%)

  const resize = (file) => new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
      const c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * scale);
      c.height = Math.round(img.naturalHeight * scale);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      const data = c.toDataURL('image/jpeg', QUALITY).split(',')[1];
      resolve({ name: file.name.replace(/\.\w+$/, '') + '.jpg', type: 'image/jpeg', data });
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(null); }; // e.g. HEIC the browser can't read
    img.src = url;
  });

  document.querySelectorAll('[data-tc-valform][data-endpoint]').forEach((form) => {
    const endpoint = form.dataset.endpoint;
    if (!endpoint) return;
    const input = form.querySelector('[data-tc-photos]');
    const list = form.querySelector('[data-tc-photos-list]');
    const err = form.querySelector('[data-tc-val-error]');
    const btn = form.querySelector('[data-tc-val-submit]');
    const max = Number(input?.dataset.max || 6);

    input?.addEventListener('change', () => {
      const files = [...input.files];
      list.innerHTML = '';
      files.slice(0, max).forEach((f) => { const li = document.createElement('li'); li.textContent = f.name; list.append(li); });
      err.hidden = files.length <= max;
      if (!err.hidden) err.textContent = `Only the first ${max} photos will be sent.`;
    });

    // Capture phase on window: runs before Shopify's CAPTCHA handler; second pass (requestSubmit) lets it run.
    window.addEventListener('submit', async (e) => {
      if (e.target !== form || form.dataset.tcSent) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      btn.disabled = true;
      btn.textContent = 'Sending…';

      const files = input ? [...input.files].filter((f) => f.type.startsWith('image/') || /\.(heic|heif)$/i.test(f.name)).slice(0, max) : [];
      let photos = (await Promise.all(files.map(resize))).filter(Boolean);
      while (photos.reduce((n, p) => n + p.data.length, 0) > MAX_TOTAL) photos = photos.slice(0, -1);

      const note = document.createElement('input');
      note.type = 'hidden';
      note.name = 'contact[Photos]';
      note.value = photos.length ? `${photos.length} photo(s) sent separately by email` : 'None attached';
      form.append(note);

      if (window.TCMake) {
        await window.TCMake.send(endpoint, window.TCMake.payload(form, { photos }));
      } else {
        try {
          const body = new URLSearchParams({ payload: JSON.stringify({ photos, page: location.href }) });
          await fetch(endpoint, { method: 'POST', mode: 'no-cors', body });
        } catch (x) { /* ignore */ }
      }
      const fields = { 'Valuation type': form.querySelector('[name="contact[Valuation type]"]')?.value || '' };

      window.dataLayer?.push({ event: 'valuation_enquiry', valuation_type: fields['Valuation type'] || '' });
      form.dataset.tcSent = '1';
      btn.disabled = false;
      if (form.requestSubmit) form.requestSubmit(btn); else HTMLFormElement.prototype.submit.call(form);
    }, true);
  });
})();
